import { ConfigConstants as Constants } from '../types'

const initialState = {
    config: null,    
    error: null,    
    loading: false   
};

export function configReducer(state = initialState, action) {
    switch (action.type) {  
        
        case Constants.GET:            
            return {
                ...state,
                config: action?.payload?.config,
                loading: false,
                error: null,
            };

                       
       
        
        case Constants.FAIL:
            return{
                ...state,
                error: action?.error,
                loading: false
            }
        
        case Constants.LOADING:
            return{
                ...state,
                error: null,
                loading: true
            }

        case Constants.CLEAR:
        default:
            return state
    }
}